import React, { FC, useContext } from 'react'
import PaymentMethodPage from 'components/PaymentMethod'
import usePaymentMethod, { CurrentOrder } from 'hooks/buffet/usePaymentMethod'
import { PaymentMethodQuery, PaymentTypeEnum } from 'graphQL/dinein/generate/operations'
import useGetUserCampaignDataPack from 'services/hooks/useGetUserCampaignDataPack'
import { serviceEndpoints } from 'variables/services'
import { AppContext } from 'contexts/AppProvider'

const { liffAPI } = serviceEndpoints

type Props = {
  handleBack: () => void
  vendorID: number
  currentOrder: CurrentOrder
  paymentMethods: PaymentTypeEnum[]
  refetchPayment: () => Promise<PaymentMethodQuery>
}

const PaymentMethodUI: FC<Props> = ({ handleBack, vendorID, currentOrder, paymentMethods, refetchPayment }) => {
  const { setCurrentUser } = useContext(AppContext)
  const {
    refreshPaymentMethod,
    onSelectPayment,
    updatePayment,
    paymentMethod,
    buffetPaymentMethods,
    setStatePaymentMethodCreditCard,
  } = usePaymentMethod({
    currentOrder: currentOrder,
    paymentMethods: paymentMethods,
    refetchData: refetchPayment,
  })

  const onUpdatePaymentMethod = async ({ cardID, type, phoneNumber }) => {
    await updatePayment({
      orderID: currentOrder.id,
      cardID: cardID ? cardID : '',
      type,
      phoneNumber: phoneNumber ? phoneNumber : '',
    })
  }

  const [{ refetch: refetchUserCampaignDataPack }] = useGetUserCampaignDataPack({
    handleIsNotLineFriend: () => {},
    apiEndpoint: liffAPI,
    onCompleted: () => {},
  })

  const onAfterRemoveCreditCardCompleted = async () => {
    setStatePaymentMethodCreditCard(null)
    const resultCurrentUser = await refetchUserCampaignDataPack()
    const resultRefetchData = await refetchPayment()
    const currentUser = resultCurrentUser?.data?.currentUser
    setCurrentUser(currentUser)
    if (resultRefetchData) {
      refreshPaymentMethod({
        currentUserByPass: currentUser,
        currentOrderByPass: resultRefetchData.currentOrder,
        isNotUseStatePaymentMethodCreditCard: true,
      })
    }
  }

  return (
    <PaymentMethodPage
      show={true}
      paymentMethod={paymentMethod}
      vendorSettingPaymentMethods={buffetPaymentMethods}
      onBack={handleBack}
      onSelectPayment={onSelectPayment}
      vendorID={vendorID}
      onUpdatePaymentMethod={onUpdatePaymentMethod}
      onAfterRemoveCreditCardCompleted={onAfterRemoveCreditCardCompleted}
    />
  )
}

export default PaymentMethodUI
